import reducer from './chat.ducks';

export { reducer };


// WEBPACK FOOTER //
// ./src/routes/Chat/index.ts